(function(){

  //function to load script
  //url is the url containing the script
  //callback is the function to execute after the script is loaded
  var loadScript = function(url, callback){
 
    var script = document.createElement("script");
    script.type = "text/javascript";

    //internet explorer
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    }
    //other browsers
    else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    //append to the head tag the script
    document.getElementsByTagName("head")[0].appendChild(script);
    
  };

  //code that I want to execute
  var myCode = function($){
    
    
    //-------------------------------------
    
    if ($("#shipping-zone")[0]){
        $('#shipping-zone').on('change', function() {
          //alert( this.value );

          $vzr = $('#vat_zone').attr("data-vzr");
          //alert($vzr);

          //vat-number
          /*
          if($vzr == 'true'){
            alert('tt-true');
          }else{
            alert('ff-false');
          }*/

          


          $('#vat-number').prop('required',false);
          
          if(this.value == 'Europe'){
            if($vzr == 'true'){
              $('#vat-number').prop('required',true);
            }
            $(".vat_number_container").css("display", "block");
          }else{
            $(".vat_number_container").css("display", "none");
          }
        });
    }
    
    
    
    
    
    //--------------------------------------
   
  };

  //if we already have jQuery we simply execute our function
  //if jQuery is undefined we load the script using noConflict
  if (typeof jQuery === 'undefined'){
    loadScript('//code.jquery.com/jquery-1.12.4.js', function(){
      jQuery = jQuery.noConflict(true);
      myCode(jQuery);
    });
  } else {
    myCode(jQuery);
  }

})();